import http from "../http-common";

class Tnedata{
    upload_tne_expense(data){
        return http.post("/upload_tne_expense", data)
    }
    compute_expense_audits(){
        return http.get("/compute_expense_audits")
    }
    upload_tne_exception(data){
        return http.post("/upload_tne_exception", data)
    }
    compute_exception_audits(){
        return http.get("/compute_exception_audits")
    }
    compute_pass_through_audits(){
        return http.get("/compute_pass_through_audits")
    }
    getLog(){
        return http.get('/get_logs')
    }
    getMetalog(){
        return http.get('/get_metadata')
    }
    downloadexpdata(date){
      return http.get('/download_data?upload_date='+date)
    }
    greaterthan800_downloadexpense(date){
        return http.get('/download_greater_expense_data?upload_date='+date)
    }
    otheraudit_downloadexpense(date){
        return http.get('/download_lesser_expense_data?upload_date='+date)
    }
    exception_download(date){
        return http.get('/download_exception_data?upload_date='+date)
    }
    allaudit_download(date){
        return http.get('/download_all_audit_data?upload_date='+date)
    }
    passthrough_download(date){
        return http.get('/download_pass_through_data?upload_date='+date)
    }
    postLog(data){
        return http.post('/upload_tne_log',data)
    }
    postdownloadlog(data){
        return http.post('/upload_download_log', data)
    }
    getDownloadLog(date){
        return http.get('/get_tne_download_logs?upload_date='+date)
    }
//Rejection
    upload_tne_rejections(data){
        return http.post("/upload_tne_rejections", data)
    }
    rejections_download(date){
        return http.get('/download_rejections_data?upload_date='+date)
    }
    compute_rejections(){
        return http.get("/compute_rejections_audits")
    }
    
}
export default new Tnedata();